import React, {useEffect, useState} from 'react';
import {getSubdomainSessionData, getUserSessionField, printError, printLog, sendRequest} from '../utils/AppUtils';
import ThemedInput from '../../common/components/themed/ThemedInput';
import ThemedButton from '../../common/components/themed/ThemedButton';
import {Anchor, GridBox, Section} from '../../common/fusion-ui';
import {useTheme} from '../../common/ProjectThemeProvider';
import {Keys, ModuleFieldsData, Modules, ReqUrls} from '../config/AppConfig';
import {checkNullStr, getJsonValue, isBoolTrue, isJsonValueTrue, setTabTitle} from '../../common/fusion-ui/utils/ReactUtils';
import {CssVariant, DefStrNA} from '../../common/fusion-ui/config/FusionConfig';
import {AppInterface} from "../index";
import {useConfig} from "../context/ConfigProvider";
import {useToast} from "../../common/fusion-ui/provider/ToastProvider";

const HelpPage = React.memo(() => {
    const TAG = "HelpPage";
    const theme = useTheme();
    const {updateConfig} = useConfig();
    const {showToast, changeToastVariant} = useToast();

    const moduleName = Modules.Help;
    const mf = ModuleFieldsData[Modules.Company];

    const [helpData, setHelpData] = useState({});


    const Fields = {
        helpInputValue: 'helpInputValue',
        helpSubmitBtn_disable: 'helpSubmitBtn_disable',
        helpSubmitBtn_asLoading: 'helpSubmitBtn_asLoading',
    };

    const [fieldsData, setFieldsData] = useState({});

    useEffect(() => {
        setTabTitle(moduleName)
        updateConfig(Keys.config_ShowTabBar, false);
        updateConfig(Keys.config_navbarCurrPage, moduleName);
        updateConfig(Keys.tracker_currPageModule, moduleName);
        updateConfig(Keys.tracker_currPageTag, TAG);
        // const pageData = getSubdomainSessionData();
        // log('useEffect.pageData:', pageData);
        setHelpData(getSubdomainSessionData());
    }, []);

    return (<>
            <AppInterface label={moduleName} showHome={true}>
                <div className={``} style={{color: theme.text}}>
                    <div>
                        <span className="ms-1 fw-semi-bold">If you need help related to this portal, please write to us (in the box, below):</span>
                        {/*input*/}
                        <ThemedInput
                            className={''}
                            asTextArea={true}
                            variant={false}
                            showMsg={false}
                            value={getField(Fields.helpInputValue)}
                            placeholder={getJsonValue(helpData, mf.helpHeader.column, DefStrNA)}
                            style={{height: '100px', minHeight: '60px', maxHeight: '260px'}}
                            onChange={(e) => updateField(Fields.helpInputValue, e.target.value)}
                        />

                        {/*submit*/}
                        <div className="d-flex w-auto mt-2">
                            <ThemedButton
                                className={'px-2 py-1 text-nowrap w-auto fs-sm-md'}
                                text={isFieldTrue(Fields.helpSubmitBtn_asLoading) ? 'Submitting...' : 'Submit'}
                                outlined={true}
                                disableVariant={'xl'}
                                variant={theme.primaryBlue}
                                asLoading={isFieldTrue(Fields.helpSubmitBtn_asLoading)}
                                disabled={isFieldTrue(Fields.helpSubmitBtn_disable)}
                                onClick={handleHelpSubmit}
                            />
                        </div>
                    </div>

                    <div className={'mt-4 ms-1 fw-semi-bold'}>OR</div>

                    <GridBox className={'px-2'} sm={12} md={[4, 1, 4]} justifyAt={'start'}>
                        <Section className={"h-100 app-section hover"}
                                 borderColor={theme.text30} style={{color: theme.text}}>
                            <div className={"fw-bold"}>Contact KOLs and Peers:</div>
                            <div className={"mt-1 fw-semi-bold"}>{getJsonValue(helpData, mf.managerName.column, DefStrNA)}</div>
                            <div>
                                <span className="fw-semi-bold">Email: &nbsp;</span>
                                <Anchor
                                    className={''}
                                    simple={true}
                                    href={`mailto:${getJsonValue(helpData, mf.managerEmail.column, DefStrNA)}`}>
                                    {getJsonValue(helpData, mf.managerEmail.column, DefStrNA)}
                                </Anchor>
                            </div>
                            <div>
                                <span className="fw-semi-bold">Phone No: &nbsp;</span>
                                <Anchor
                                    className={''}
                                    simple={true}
                                    href={`tel:${getJsonValue(helpData, mf.managerPhone.column, DefStrNA)}`}>
                                    {getJsonValue(helpData, mf.managerPhone.column, DefStrNA)}
                                </Anchor>
                            </div>
                        </Section>

                        <div className="fw-semi-bold d-flex jc-center">OR</div>

                        <Section className={"h-100 app-section hover"}
                                 borderColor={theme.text30} style={{color: theme.text}}>
                            <div className={"fw-bold"}>Contact Medical Services:</div>
                            {/*<div className={"mt-1 fw-semi-bold"}>{getJsonValue(helpData, mf.managerName.column, DefStrNA)}</div>*/}
                            <div className={'mt-1'}>
                                <span className="fw-semi-bold">Email: &nbsp;</span>
                                <Anchor
                                    className={''}
                                    simple={true}
                                    href={`mailto:medinfo.india@sanofi.com`}>
                                    {'medinfo.india@sanofi.com'}
                                </Anchor>
                            </div>
                            <div>
                                <span className="fw-semi-bold">Phone No: &nbsp;</span>
                                <Anchor
                                    className={''}
                                    simple={true}
                                    href={`tel:022 28032343`}>
                                    {`022 28032343`}
                                </Anchor>
                            </div>
                        </Section>
                    </GridBox>

                    {/*helpBottom*/}
                    <div className={'mt-3'}>
                        <div className={'m-0 p-0 px-2 w-100 text-wrap'}
                             style={{color: theme.text}}
                             dangerouslySetInnerHTML={{__html: getJsonValue(helpData, mf.helpBottom.column, DefStrNA)}}/>
                    </div>
                </div>
            </AppInterface>
        </>
    );

    async function handleHelpSubmit() {
        const fun = 'handleHelpSubmit:';
        try {
            const helpText = getField(Fields.helpInputValue);
            //null-checks
            if (!checkNullStr(helpText)) {
                toast('Please write something in box above!', CssVariant.warning);
                return false;
            }

            const proceed = true;
            if (proceed) {
                updateField(Fields.helpSubmitBtn_asLoading, true);
                updateField(Fields.helpSubmitBtn_disable, true);

                const REQ_OPTIONS = {
                    helpText,
                    userEmail: getUserSessionField('email'),
                    companyData: getSubdomainSessionData(),
                };

                sendRequest({
                    reqUrl: ReqUrls.helpPage__submitHelpForm,
                    reqOptions: REQ_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);
                        const success = isJsonValueTrue(fetchedData, 'success');
                        const message = getJsonValue(fetchedData, 'message');

                        if (success) {
                            toast(message, CssVariant.success);
                            // updateField(Fields.helpInputValue,'');
                        } else {
                            toast(message, CssVariant.danger);
                        }
                        updateField(Fields.helpSubmitBtn_asLoading, false);
                        updateField(Fields.helpSubmitBtn_disable, false);
                    }),
                    onError: ((error) => {
                        logErr(fun, error);
                        toast(`Submission failed, please try again`, CssVariant.danger);
                        updateField(Fields.helpSubmitBtn_asLoading, false);
                        updateField(Fields.helpSubmitBtn_disable, false);
                    }),
                });
            }
        } catch (error) {
            logErr(fun, error);
            toast(`Submission failed, please try again`, CssVariant.danger);
            updateField(Fields.helpSubmitBtn_asLoading, false);
            updateField(Fields.helpSubmitBtn_disable, false);
        }
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});
export default HelpPage;
